export const errorsText = {
  OUTSIDE_ORGANIZATION: {
    DESCRIPTION: "This report belongs to another organization. Please contact support if you believe this is in error.",
  },
  EMPTY: {
    DESCRIPTION:
      "This configuration did not return any results. You can try adjusting the filters, limits, or time range.",
  },
  SERIES_TOO_LARGE: {
    DESCRIPTION:
      "This configuration yielded a result too large to display. You can try adjusting the filters, limits, or time range.",
  },
  TOO_LARGE: {
    DESCRIPTION:
      "This configuration yielded a result too large to display. You can try adjusting the filters, limits, or time range.",
  },
  QUERY_TIMEOUT: {
    DESCRIPTION:
      "Well, looks like this report is taking too long to compute.<br />Please try again later or contact support.",
  },
  EMPTY_DUE_TO_TREND: {
    DESCRIPTION:
      "This report doesn't have any trending dimensions.<br />Try removing Trending Up/Down checkbox, please.",
  },
  QUERY_TIMEOUT_524: {
    TITLE: "This report took too long to run",
    DESCRIPTION:
      "This report is too large to run. Consider reducing the scope or use the <b>Cache report</b> option to view the report later when it's available. You'll also get an <b>email and in-app notification</b> when the report is ready. ",
  },
  EXCEEDED_FIRESTORE_LIMIT: {
    DESCRIPTION:
      "This configuration failed due to exceeded_firestore_limit. You can try adjusting the filters, limits, or time range, or contact support if the issue persists.",
  },
  DEFAULT: {
    DESCRIPTION:
      "This configuration failed due to unknown_error. You can try adjusting the filters, limits, or time range, or contact support if the issue persists.",
  },
  CACHE_REPORT_BTN: "Cache report",
  NOT_EDITOR_TOOLTIP: "Please contact the report owner to be given permission to cache this report",
  NOT_SAVED_TOOLTIP: "Please save the report before caching",
  ENTITLEMENT_NOT_ENABLED: {
    DESCRIPTION:
      "This configuration failed due to entitlement_not_enabled. You can try adjusting the filters, limits, or time range, or contact support if the issue persists.",
  },
  LEARN_MORE: "Learn more",
  NO_ACCESS_METRIC:
    "This configuration failed due to calculated_metric_not_provided. You can try adjusting the filters, limits, or time range, or contact support if the issue persists.",
  NO_ACCESS_METRIC_EXTENDED:
    "This configuration failed due to extended_metric_not_provided. You can try adjusting the filters, limits, or time range, or contact support if the issue persists.",
  BQ_PROXY_NOT_FOUND: {
    DESCRIPTION:
      "This configuration failed due to bq_lens_proxy_not_found. You can try adjusting the filters, limits, or time range, or contact support if the issue persists.",
  },
  BQ_PROXY_FORBIDDEN: {
    DESCRIPTION:
      "This configuration failed due to bq_lens_proxy_forbidden. You can try adjusting the filters, limits, or time range, or contact support if the issue persists.",
  },
  BQ_PROXY_IAM_PERMISSION_DENIED: {
    DESCRIPTION:
      "This configuration failed due to bq_lens_proxy_iam_permission. You can try adjusting the filters, limits, or time range, or contact support if the issue persists.",
  },
  AVA_ERROR: {
    DESCRIPTION:
      "Ava couldn't generate a report based on your prompt. Try a different prompt and if the problem persists, please contact support.",
  },
  FAILED_TO_CACHE: {
    TITLE: "This report failed to cache",
    DESCRIPTION:
      "Consider limiting the report results or shorten the report time range and try <b>Cache report</b> again. If the problem persists, please contact support.",
  },
  EXPERT_INQUIRY: "Expert inquiry",
};
